import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ToggleButtonNotEmpty from './ToggleButtonNotEmpty';
import ClientProvider from './client';
export default createDemo(import.meta.url, ToggleButtonNotEmpty, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/toggle-button/demos/not-empty/ToggleButtonNotEmpty.tsx",
    "fileName": "ToggleButtonNotEmpty.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport LaptopIcon from '@mui/icons-material/Laptop';\nimport TvIcon from '@mui/icons-material/Tv';\nimport PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';\nimport Stack from '@mui/material/Stack';\nimport ToggleButton from '@mui/material/ToggleButton';\nimport ToggleButtonGroup from '@mui/material/ToggleButtonGroup';\n\nexport default function ToggleButtonNotEmpty() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [alignment, setAlignment] = React.useState('left');\n  const [devices, setDevices] = React.useState(() => ['phone']);\n\n  const handleAlignment = (\n    event: React.MouseEvent<HTMLElement>,\n    newAlignment: string | null,\n  ) => {\n    if (newAlignment !== null) {\n      setAlignment(newAlignment);\n    }\n  };\n\n  const handleDevices = (\n    event: React.MouseEvent<HTMLElement>,\n    newDevices: string[],\n  ) => {\n    if (newDevices.length) {\n      setDevices(newDevices);\n    }\n  };\n\n  return (\n    <Stack direction=\"row\" spacing={4}>\n      <ToggleButtonGroup\n        value={alignment}\n        exclusive\n        onChange={handleAlignment}\n        aria-label=\"text alignment\"\n      >\n        <ToggleButton value=\"left\" aria-label=\"left aligned\">\n          <FormatAlignLeftIcon />\n        </ToggleButton>\n        <ToggleButton value=\"center\" aria-label=\"centered\">\n          <FormatAlignCenterIcon />\n        </ToggleButton>\n        <ToggleButton value=\"right\" aria-label=\"right aligned\">\n          <FormatAlignRightIcon />\n        </ToggleButton>\n      </ToggleButtonGroup>\n\n      <ToggleButtonGroup\n        value={devices}\n        onChange={handleDevices}\n        aria-label=\"device\"\n      >\n        <ToggleButton value=\"laptop\" aria-label=\"laptop\">\n          <LaptopIcon />\n        </ToggleButton>\n        <ToggleButton value=\"tv\" aria-label=\"tv\">\n          <TvIcon />\n        </ToggleButton>\n        <ToggleButton value=\"phone\" aria-label=\"phone\">\n          <PhoneAndroidIcon />\n        </ToggleButton>\n      </ToggleButtonGroup>\n    </Stack>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 70,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport LaptopIcon from '@mui/icons-material/Laptop';\nimport TvIcon from '@mui/icons-material/Tv';\nimport PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';\nimport Stack from '@mui/material/Stack';\nimport ToggleButton from '@mui/material/ToggleButton';\nimport ToggleButtonGroup from '@mui/material/ToggleButtonGroup';\n\nexport default function ToggleButtonNotEmpty() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [alignment, setAlignment] = React.useState('left');\n  const [devices, setDevices] = React.useState(() => ['phone']);\n\n  const handleAlignment = (\n    event: React.MouseEvent<HTMLElement>,\n    newAlignment: string | null,\n  ) => {\n    if (newAlignment !== null) {\n      setAlignment(newAlignment);\n    }\n  };\n\n  const handleDevices = (\n    event: React.MouseEvent<HTMLElement>,\n    newDevices: string[],\n  ) => {\n    if (newDevices.length) {\n      setDevices(newDevices);\n    }\n  };\n\n  return (\n    <Stack direction=\"row\" spacing={4}>\n      <ToggleButtonGroup\n        value={alignment}\n        exclusive\n        onChange={handleAlignment}\n        aria-label=\"text alignment\"\n      >\n        <ToggleButton value=\"left\" aria-label=\"left aligned\">\n          <FormatAlignLeftIcon />\n        </ToggleButton>\n        <ToggleButton value=\"center\" aria-label=\"centered\">\n          <FormatAlignCenterIcon />\n        </ToggleButton>\n        <ToggleButton value=\"right\" aria-label=\"right aligned\">\n          <FormatAlignRightIcon />\n        </ToggleButton>\n      </ToggleButtonGroup>\n\n      <ToggleButtonGroup\n        value={devices}\n        onChange={handleDevices}\n        aria-label=\"device\"\n      >\n        <ToggleButton value=\"laptop\" aria-label=\"laptop\">\n          <LaptopIcon />\n        </ToggleButton>\n        <ToggleButton value=\"tv\" aria-label=\"tv\">\n          <TvIcon />\n        </ToggleButton>\n        <ToggleButton value=\"phone\" aria-label=\"phone\">\n          <PhoneAndroidIcon />\n        </ToggleButton>\n      </ToggleButtonGroup>\n    </Stack>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 70,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/icons-material/FormatAlignLeft",
      "@mui/icons-material/FormatAlignCenter",
      "@mui/icons-material/FormatAlignRight",
      "@mui/icons-material/Laptop",
      "@mui/icons-material/Tv",
      "@mui/icons-material/PhoneAndroid",
      "@mui/material/Stack",
      "@mui/material/ToggleButton",
      "@mui/material/ToggleButtonGroup"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
